import { TextField } from '@fs/zion-ui'
import React, { useEffect, useState } from 'react'
import { useQueryParams } from '@fs/zion-router'
import debounce from 'lodash.debounce'
import { useTimeTravel } from '@fs/zion-rootstech'
import { getNowTimestamp, parseISOtoMs, parseMsToISO, roundTimestampDown } from '../helpers'
import { useOnce } from '../../hooks'

const DateTimeField = (props) => {
  return <TextField label="Time" type="datetime-local" {...props} />
}

export default function TimeSelector({ paramKey, isOpen }) {
  const { query, setQuery, removeQuery } = useQueryParams()
  const { getNow, setNow } = useTimeTravel()
  const ISONow = parseMsToISO(roundTimestampDown({ time: getNow() }), true)
  const now = ISONow.replace('.000Z', '')
  const [value, setValue] = useState(now)

  // NOTE: onChange may be called twice when clearing the field due to debounce function recreation on each render
  const onChange = debounce(
    (e) => {
      const newNow = e.target.value
      if (newNow) {
        setValue(newNow)
        setNow(parseISOtoMs(newNow))
        setQuery({ [paramKey]: newNow })
      } else {
        setValue(now)
        setNow(getNowTimestamp())
        removeQuery(paramKey)
      }
    },
    1000,
    { leading: true }
  )

  const onOnce = useOnce()
  useEffect(() => {
    if (isOpen) {
      onOnce(() => onChange({ target: { value: query[paramKey] } }))
    }
  }, [isOpen, onChange, onOnce, paramKey, query])

  return <DateTimeField value={value} onChange={onChange} />
}
